import type { Omraade } from "#lib/types/omraade.js";

export type AreaCode = "NO1" | "NO2" | "NO3" | "NO4" | "NO5";

export const isAreaCode = (area: string): area is AreaCode =>
	["NO1", "NO2", "NO3", "NO4", "NO5"].includes(area);

export const selectAreas: Omraade[] = [
	{
		value: "NO1",
		label: "Sørøst-Norge",
		shortLabel: "Sørøst",
		urlLabel: "sorost",
		seoSlug: "sorost-norge",
	},
	{
		value: "NO2",
		label: "Sørvest-Norge",
		shortLabel: "Sørvest",
		urlLabel: "sorvest",
		seoSlug: "sorvest-norge",
	},
	{
		value: "NO3",
		label: "Midt-Norge",
		shortLabel: "Midt",
		urlLabel: "midt",
		seoSlug: "midt-norge",
	},
	{
		value: "NO4",
		label: "Nord-Norge",
		shortLabel: "Nord",
		urlLabel: "nord",
		seoSlug: "nord-norge",
	},
	{
		value: "NO5",
		label: "Vest-Norge",
		shortLabel: "Vest",
		urlLabel: "vest",
		seoSlug: "vest-norge",
	},
];

export const selectAreasExtended: Omraade[] = [
	...selectAreas,
	{
		value: "NO4-2",
		label: "Nord-Troms/Finnmark",
		shortLabel: "Troms/Finnmark",
		urlLabel: "troms-finnmark",
		seoSlug: "nord-troms-finnmark",
	},
];

export const getAreaCodeBySeoSlug = (slug: string): AreaCode | undefined =>
	selectAreas.find((a) => a.seoSlug === slug)?.value as AreaCode | undefined;
